var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          {
            staticClass:
              "generic--template food-and-drink page-template bg-beige",
          },
          [
            _c("div", { staticClass: "relative bg-sf-color z-content" }, [
              _c("div", { staticClass: "row relative center mb4 mt4-ns" }, [
                _c("div", {
                  staticClass: "relative center col-xs-12 col-sm-6 ph0",
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "relative container-fluid  mw9 center taste-top",
                },
                [
                  _c("h1", {
                    staticClass:
                      "tl center pl3 fiveem lh-heading ttu is-blenny is-navy",
                    domProps: { innerHTML: _vm._s(_vm.marked(_vm.page.title)) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row relative center height-rest mb4 mt4-ns",
                    },
                    [
                      _c("div", { staticClass: "w-100  col-sm-6" }, [
                        _c("img", {
                          staticClass: "img-responsive",
                          attrs: { src: "/uploads/west-optimized.jpg" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "relative col-xs-12 col-sm-6 ph0" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dn des-rest db-ns abs-vert-center center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "db des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.page.intro_text) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("section", { staticClass: "relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative container-fluid center smaller-list rest-list",
                  },
                  [
                    _c(
                      "h1",
                      {
                        staticClass:
                          "center is-tablet-bold is-navy second-title",
                      },
                      [_vm._v("\n              CRAFT VENDORS\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "restaurant-border col-sm-10 mt0 mt4-ns",
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "scrollanimation",
                                  rawName: "v-scrollanimation",
                                },
                              ],
                              staticClass: "row mt4",
                            },
                            _vm._l(_vm.beerData, function (restaurant) {
                              return _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-4 pb4" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "flex relative flex-row items-center is-tablet-bold f24px ttn is-navy rest-partner",
                                      attrs: {
                                        href: restaurant.link,
                                        title: restaurant.title,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "is-tablet-bold is-black f20px",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(restaurant.title) +
                                              " \n                          "
                                          ),
                                          restaurant.winner === "x"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "delivery-icon is-red",
                                                },
                                                [_c("strong", [_vm._v("*")])]
                                              )
                                            : _c("span", {}),
                                          _vm._v(" "),
                                          _c("simple-svg", {
                                            staticClass:
                                              "vendor-arrow r45 nl2 pb2 pr1",
                                            attrs: {
                                              filepath:
                                                "/uploads/checkout-arrow.svg",
                                            },
                                          }),
                                          _vm._v(" "),
                                          restaurant.is_takeout_only === true
                                            ? _c(
                                                "span",
                                                { staticClass: "takeout-icon" },
                                                [_c("strong", [_vm._v("T")])]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          restaurant.is_delivery_only === true
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "delivery-icon",
                                                },
                                                [_c("strong", [_vm._v("D")])]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          restaurant.is_ca_shipping === true
                                            ? _c("span", {
                                                staticClass:
                                                  "ml1 ca-icon-inline",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          restaurant.diet ===
                                          "At least one of our items will be vegetarian (or can be adjusted upon request), At least one of our items will be gluten-free (or can be adjusted upon request)"
                                            ? _c(
                                                "span",
                                                { staticClass: "takeout-icon" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("V / GF"),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("h1", { staticClass: "craft-font" }, [
                      _vm._v(
                        "* The WCC x OL Scholarship Program awards 15% of the booths in the marketplace to BIPOC artist and designer craftspeople."
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "relative container-fluid height-rest mw9 center",
                }),
              ]),
            ]),
            _vm._v(" "),
            _vm.isWindowWidthMobile == true &&
            _vm.page.featured_content_section.is_published
              ? _c(
                  "div",
                  { staticClass: "relative bg-light-blue z-content mb5" },
                  [
                    _c(
                      "section",
                      { staticClass: "relative center pv4 is-black" },
                      [
                        _c(
                          "swiper",
                          {
                            ref: "mySwiper",
                            attrs: { options: _vm.swiperOptions },
                          },
                          [
                            _c("swiper-slide", [
                              _c(
                                "div",
                                { staticClass: "relative container-fluid" },
                                [
                                  _c("div", { staticClass: "db w-100" }, [
                                    _c("img", {
                                      staticClass:
                                        "db relative center img-responsive w-100",
                                      attrs: {
                                        src: _vm.page.featured_content_section
                                          .content["0"].image,
                                        alt: _vm.page.featured_content_section
                                          .content["0"].image.alt,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f20px is-tablet-cond-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["0"].title
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "f15px is-tablet-regular mb3 lh-copy",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["0"].text
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "f15px is-tablet-bold",
                                        attrs: {
                                          title:
                                            _vm.page.featured_content_section
                                              .content["0"].link_title,
                                          href: _vm.page
                                            .featured_content_section.content[
                                            "0"
                                          ].link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].button_text
                                          )
                                        ),
                                        _c("simple-svg", {
                                          staticClass: "checkout",
                                          attrs: {
                                            filepath:
                                              "/uploads/checkout-arrow.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("swiper-slide", [
                              _c(
                                "div",
                                { staticClass: "relative container-fluid" },
                                [
                                  _c("div", { staticClass: "db w-100" }, [
                                    _c("img", {
                                      staticClass:
                                        "db relative center img-responsive w-100",
                                      attrs: {
                                        src: _vm.page.featured_content_section
                                          .content["1"].image,
                                        alt: _vm.page.featured_content_section
                                          .content["1"].image.alt,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f20px is-tablet-cond-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["1"].title
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "f15px is-tablet-regular mb3 lh-copy",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["1"].text
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "f15px is-tablet-bold",
                                        attrs: {
                                          title:
                                            _vm.page.featured_content_section
                                              .content["1"].link_title,
                                          href: _vm.page
                                            .featured_content_section.content[
                                            "1"
                                          ].link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].button_text
                                          )
                                        ),
                                        _c("simple-svg", {
                                          staticClass: "checkout",
                                          attrs: {
                                            filepath:
                                              "/uploads/checkout-arrow.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isWindowWidthMobile == false &&
            _vm.page.featured_content_section.is_published
              ? _c(
                  "div",
                  { staticClass: "relative bg-light-blue z-content mb5 mt4" },
                  [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "section",
                        { staticClass: "relative center mw8 pt5 pb5 is-black" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream",
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "db relative center img-responsive w-100",
                                  attrs: {
                                    src: _vm.page.featured_content_section
                                      .content["0"].image,
                                    alt: _vm.page.featured_content_section
                                      .content["0"].image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f20px is-tablet-cond-bold mt4 mb3",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].title
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "f15px is-tablet-regular mb3 lh-copy",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].text
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "f15px is-tablet-bold",
                                    attrs: {
                                      title:
                                        _vm.page.featured_content_section
                                          .content["0"].link_title,
                                      href: _vm.page.featured_content_section
                                        .content["0"].link,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].button_text
                                      )
                                    ),
                                    _c("simple-svg", {
                                      staticClass: "checkout",
                                      attrs: {
                                        filepath: "/uploads/checkout-arrow.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l",
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "db relative center img-responsive w-100 pt4 pt0-m pt0-l",
                                  attrs: {
                                    src: _vm.page.featured_content_section
                                      .content["1"].image,
                                    alt: _vm.page.featured_content_section
                                      .content["1"].image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f20px is-tablet-cond-bold mt4 mb3",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].title
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "f15px is-tablet-regular mb3 lh-copy",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].text
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "f15px is-tablet-bold",
                                    attrs: {
                                      title:
                                        _vm.page.featured_content_section
                                          .content["1"].link_title,
                                      href: _vm.page.featured_content_section
                                        .content["1"].link,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].button_text
                                      )
                                    ),
                                    _c("simple-svg", {
                                      staticClass: "checkout",
                                      attrs: {
                                        filepath: "/uploads/checkout-arrow.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }